import { Button, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { cropPhone, formatPhone } from './utils';

export interface ICroppedPhoneProps {
  phone: string;
  isCropped: boolean;
  onClick(): void;
}

export function CroppedPhone({ phone, isCropped, onClick }: ICroppedPhoneProps) {
  const text = React.useMemo(() => (isCropped ? cropPhone(phone) : formatPhone(phone)), [phone, isCropped]);

  return (
    <UIText2>
      <Button size="XS" theme="fill_secondary" onClick={onClick}>
        {text}
      </Button>
    </UIText2>
  );
}
